import { useEffect, useState } from 'react';

/**
 * useMediaQuery — Subscribe to a CSS media query and get whether it matches.
 * Used to toggle mobile-only layout behavior (e.g. off-canvas sidebar).
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}
